import { CognitoAuthUserHandler } from 'amazon-cognito-auth-js';

import { client } from './client';

export const setUserhandler = (handler: CognitoAuthUserHandler) =>
  (client.userhandler = handler);
